import type { UpdateExperienceRequest } from 'app/typings/core/admin/experiences/experienceForm';
import {
  getRejectedFields,
  makeTabFieldErrorHelpers,
} from 'app/utils/tabFieldErrors';

import { MenuItemName } from './menuItem';

type FormOnlyField =
  | 'experienceType'
  | 'hotelId'
  | 'originalId'
  | 'lastMinuteRule'
  | 'maxAddonQuantity'
  | 'showInInventory'
  | 'roomServiceAvailable'
  | 'roomServiceIncluded';

type RenamedPayloadField = 'isRoomServiceAvailable' | 'isRoomServiceIncluded';

export type ExperienceFormField =
  Exclude<keyof UpdateExperienceRequest, RenamedPayloadField> | FormOnlyField;

export const EXPERIENCE_TAB_FIELDS = {
  [MenuItemName.General]: [
    'categoryId',
    'experienceType',
    'hotelId',
    'originalId',
    'duration',
    'durationDescription',
    'location',
    'brand',
    'time',
    'emoji',
  ],
  [MenuItemName.Accessibility]: [
    'accessMode',
    'spaceIds',
    'roomServiceAvailable',
    'roomServiceIncluded',
    'roomServicePrice',
    'openingHours',
    'availableDayLimits',
    'closingPeriods',
    'lastMinuteRule',
    'closedDaysBeforeCheckIn',
    'maxAddonQuantity',
    'maxQuantity',
  ],
  [MenuItemName.Availability]: [
    'availabilityMode',
    'isTimeslotDaytimeOnly',
    'showInInventory',
    'allowedPaxTypes',
    'minPax',
    'maxPax',
    'isAlwaysIncludedWithNight',
    'openingConfiguration',
  ],
  [MenuItemName.Copywriting]: [
    'description',
    'tagline',
    'importantInformation',
    'menu',
    'treatmentList',
  ],
  [MenuItemName.Medias]: ['coverPicture', 'experiencePictures', 'emoji'],
} as const satisfies Record<MenuItemName, readonly ExperienceFormField[]>;

type MappedField = (typeof EXPERIENCE_TAB_FIELDS)[MenuItemName][number];
type UnmappedField = Exclude<ExperienceFormField, MappedField>;

export const everyExperienceFieldIsMapped: [UnmappedField] extends [never]
  ? true
  : UnmappedField = true;

export const { activeTabHasFieldError, getFirstActiveTabErrorField } =
  makeTabFieldErrorHelpers<MenuItemName>(EXPERIENCE_TAB_FIELDS);

export { getRejectedFields };
